define([
    'prop-types',
    'lodash',
    'skins',
    'coreUtils',
    'santa-components'],
function (PropTypes, _, skins, coreUtils, santaComponents) {
    'use strict';

    const CONTROLLER_PREVIEW_SKIN = 'platform.components.skins.controllerIconAndNameSkin';
    const CONTROLLER_PREVIEW_STYLE_ID = coreUtils.santaTypes.shortenStyleId(CONTROLLER_PREVIEW_SKIN);

    const SantaTypes = santaComponents.santaTypesDefinitions;

    const getCompCss = (styleId, props) => {
        const {
            getStyleData,
            themeData,
            siteZoomRatio,
            invertedZoomRatio,
            orientationZoomFix,
            mobileZoom,
            scriptsLocationMap
        } = props;

        const styleData = getStyleData(styleId);
        const mobileData = {siteZoomRatio, invertedZoomRatio, orientationZoomFix, mobileZoom};
        const serviceTopology = {scriptsLocationMap};
        const skinData = skins.skinsMap.get(CONTROLLER_PREVIEW_SKIN);
        const styleProps = _.get(styleData, 'style.properties', {});

        return {[CONTROLLER_PREVIEW_STYLE_ID]: santaComponents.utils.skinsRenderer.createSkinCss(skinData, styleProps, themeData, CONTROLLER_PREVIEW_STYLE_ID, mobileData, serviceTopology)};
    };

    getCompCss.cssTypes = {
        getStyleData: santaComponents.santaTypesDefinitions.Component.getStyleData,
        themeData: santaComponents.santaTypesDefinitions.Theme.THEME_DATA,
        siteZoomRatio: santaComponents.santaTypesDefinitions.Mobile.siteZoomRatio,
        invertedZoomRatio: santaComponents.santaTypesDefinitions.Mobile.invertedZoomRatio,
        orientationZoomFix: santaComponents.santaTypesDefinitions.Mobile.orientationZoomFix,
        mobileZoom: santaComponents.santaTypesDefinitions.Mobile.mobileZoom,
        scriptsLocationMap: santaComponents.santaTypesDefinitions.ServiceTopology.scriptsLocationMap
    };

    return baseClass => {
        class ControllerPreview extends baseClass {
            transformRefData(refData) {
                refData.icon = refData.icon || {}; // eslint-disable-line santa/no-side-effects
                refData.icon.src = _.get(this.props.applicativeUIData, 'icon');
                refData.name = refData.name || {}; // eslint-disable-line santa/no-side-effects
                refData.name.children = this.props.compData.name;
            }
        }

        ControllerPreview.defaultProps = {
            skin: CONTROLLER_PREVIEW_SKIN,
            styleId: CONTROLLER_PREVIEW_STYLE_ID
        };
        ControllerPreview.getCompCss = getCompCss;
        ControllerPreview.propTypes = _.defaults({
            applicativeUIData: SantaTypes.AppController.applicativeUIData,
            skin: coreUtils.staticValue(PropTypes.string, CONTROLLER_PREVIEW_SKIN),
            styleId: coreUtils.staticValue(PropTypes.string, CONTROLLER_PREVIEW_STYLE_ID),
            isMobile: SantaTypes.isMobileView.isRequired,
            isVisible: SantaTypes.AppController.isVisible.isRequired,
            compData: SantaTypes.Component.compData.isRequired
        }, baseClass.propTypes);

        ControllerPreview.displayName = `${baseClass.displayName}Preview)`;

        return ControllerPreview;
    };
});
